import { api } from "@/api"

type RetrieveUserResponse = {
  id: string
  email: string
  firstName: string
  lastName: string
  isActive: boolean
}

export const retrieveUser = async (userId: string) => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<RetrieveUserResponse>
  >(`/users/${userId}/`)

  return body
}
